import { useCallback } from "react";
import {
  getEGiftCardDetail,
  getDeleteEGiftCardInfo,
  recallEGiftCard,
  restockEGiftCard,
} from "../api/eGiftCard.api";
import type {
  DeleteEGiftCardInfoResponse,
  RecallEGiftCardResponse,
  RestockEGiftCardRequest,
  RestockEGiftCardResponse,
} from "../types/eGiftCard.types";

export const useEGiftCardActions = () => {
  const fetchEGiftCardDetailForRestock = useCallback(async (id: string): Promise<RestockEGiftCardRequest | null> => {
    try {
      const eGiftCard = await getEGiftCardDetail(id);
      return {
        coupon_id: eGiftCard.id || "",
        coupon_name:
          eGiftCard.title || eGiftCard.merchant_name || String(eGiftCard.value),
        created_quantity: eGiftCard.quantity || 0,
        available_quantity: Math.max(0, eGiftCard.quantity - eGiftCard.used_quantity),
        restock_quantity: null,
      };
    } catch (error) {
      console.error("Failed to fetch e-gift-card detail for restock:", error);
      return null;
    }
  }, []);

  const handleRestockEGiftCard = useCallback(async (
    eGiftCardId: string,
    quantity: number,
  ): Promise<RestockEGiftCardResponse | null> => {
    try {
      return await restockEGiftCard(eGiftCardId, quantity);
    } catch (error) {
      console.error("Failed to restock e-gift card:", error);
      return null;
    }
  }, []);

  const fetchDeleteEGiftCardInfo = useCallback(async (eGiftCardId: string): Promise<DeleteEGiftCardInfoResponse | null> => {
    try {
      return await getDeleteEGiftCardInfo(eGiftCardId);
    } catch (error) {
      console.error("Failed to fetch e-gift-card delete information:", error);
      return null;
    }
  }, []);

  const handleRecallEGiftCard = useCallback(async (eGiftCardId: string): Promise<RecallEGiftCardResponse | null> => {
    try {
      return await recallEGiftCard(eGiftCardId);
    } catch (error) {
      console.error("Failed to recall e-gift card:", error);
      return null;
    }
  }, []);

  return {
    fetchEGiftCardDetailForRestock,
    handleRestockEGiftCard,
    fetchDeleteEGiftCardInfo,
    handleRecallEGiftCard,
  };
};
